export const dashboardRu = {
  title: "Панель управления",
  greeting: "Привет, %{name}!",
  userFallback: "пользователь",
  phraseHint: "Управление мотивационными фразами для модуля эмоций",
  musicHint: "Загрузка и редактирование треков для релаксации",
  emotionsHint: "Просмотр записей эмоций пациентов",
};

export const dashboardEn = {
  title: "Dashboard",
  greeting: "Hello, %{name}!",
  userFallback: "user",
  phraseHint: "Manage motivational phrases for the emotions module",
  musicHint: "Upload and edit relaxation music tracks",
  emotionsHint: "View patient emotion records",
};

export const dashboardAz = {
  title: "İdarə paneli",
  greeting: "Salam, %{name}!",
  userFallback: "istifadəçi",
  phraseHint: "Emosiyalar modulu üçün motivasiya ifadələrinin idarə edilməsi",
  musicHint: "Rahatladıcı musiqi treklərinin yüklənməsi və redaktəsi",
  emotionsHint: "Xəstələrin emosiya qeydlərinə baxış",
};
